import { gql } from "@apollo/client";

export const DND_FIELDS = gql`
  fragment DND_FIELDS on dnd {
    id
    title
  }
`;
